var map = {
	"./avatars/1-small.png": "28a5",
	"./avatars/1.png": "f7d6",
	"./avatars/10-small.png": "ceac",
	"./avatars/10.png": "e929",
	"./avatars/11-small.png": "b922",
	"./avatars/11.png": "2b14",
	"./avatars/12-small.png": "5e8f",
	"./avatars/12.png": "3fb4",
	"./avatars/13-small.png": "977a",
	"./avatars/13.png": "dbcc",
	"./avatars/2-small.png": "f548",
	"./avatars/2.png": "3e88",
	"./avatars/3-small.png": "a921",
	"./avatars/3.png": "e251",
	"./avatars/4-small.png": "103d",
	"./avatars/4.png": "5235",
	"./avatars/5-small.png": "da2a",
	"./avatars/5.png": "7df9",
	"./avatars/6-small.png": "73bb",
	"./avatars/6.png": "045e",
	"./avatars/7-small.png": "af6d",
	"./avatars/7.png": "c7c0",
	"./avatars/8-small.png": "09d5",
	"./avatars/8.png": "2825",
	"./avatars/9-small.png": "f8f8",
	"./avatars/9.png": "2305",
	"./badges/completed.png": "f0b4",
	"./badges/extraordinary.png": "5f7d",
	"./badges/first-ribbon.png": "0b48",
	"./badges/perseverance-badge.png": "cf79",
	"./badges/ribbon.png": "e71e",
	"./badges/streak-badge.png": "8dfa",
	"./chatbot/Android_Female_Happy_Talk_.png": "c244",
	"./chatbot/Android_Female_Happy_idle_.png": "b29f",
	"./chatbot/Android_Female_idle.png": "a439",
	"./chatbot/Android_Female_talking.png": "928a",
	"./chatbot/Android_Male_Happy_idle_.png": "5e22",
	"./chatbot/Android_Male_Happy_talk_.png": "aa63",
	"./chatbot/Android_man_avatar_idle_.png": "3676",
	"./chatbot/Android_man_avatar_talk_.png": "05d2",
	"./chatbot/JP_MAN_IDLE.png": "ce11",
	"./chatbot/JP_MAN_TALKING.png": "c4db",
	"./chatbot/JP_WOMAN_IDLE.png": "ba18",
	"./chatbot/JP_WOMAN_TALKING.png": "1c31",
	"./elements/decore-left.png": "8ee6",
	"./elements/decore-right.png": "ee15",
	"./elements/encourage.png": "a469",
	"./elements/image_2023_03_30T11_47_00_253Z.png": "7de5",
	"./elements/keep-trying.png": "4ff1",
	"./elements/no-data.png": "e584",
	"./elements/start-again-img.png": "f82e",
	"./elements/waiting.png": "6657",
	"./flags/cn.png": "5710",
	"./flags/de.png": "72fe",
	"./flags/en.png": "9996",
	"./flags/es.png": "20ca",
	"./flags/fr.png": "26fc",
	"./flags/in.png": "17c5",
	"./flags/jp.png": "f512",
	"./flags/kr.png": "b287",
	"./flags/my.png": "58af",
	"./flags/pt.png": "5e3c",
	"./flags/turkey.png": "dc72",
	"./flags/us.png": "0684",
	"./flags/vn.png": "f91b",
	"./icons/angular.svg": "9451",
	"./icons/apple-safari.png": "4f49",
	"./icons/book.svg": "a337",
	"./icons/bootstrap.svg": "2ea3",
	"./icons/bot.png": "2f82",
	"./icons/brush.svg": "815f",
	"./icons/doc.png": "493f",
	"./icons/drive.png": "8f4a",
	"./icons/dropbox.png": "0e4f",
	"./icons/education.png": "e201",
	"./icons/figma.svg": "7472",
	"./icons/file-icons/doc.png": "61d5",
	"./icons/file-icons/onedrive.png": "37bc",
	"./icons/file-icons/pdf.png": "a235",
	"./icons/file-icons/psd.png": "051b",
	"./icons/file-icons/sketch.png": "2863",
	"./icons/font.png": "c40c",
	"./icons/google-chrome.png": "d8dc",
	"./icons/hark": "02f5",
	"./icons/hark.json": "02f5",
	"./icons/icloud-1.png": "e4ab",
	"./icons/icloud.png": "9431",
	"./icons/internet-explorer.png": "d7bc",
	"./icons/internet.png": "beef",
	"./icons/jpg.png": "1568",
	"./icons/js.png": "2710",
	"./icons/json.png": "0ec4",
	"./icons/mic.png": "70db",
	"./icons/mozila-firefox.png": "9fa4",
	"./icons/new-book.svg": "b61e",
	"./icons/onedrive.png": "8250",
	"./icons/onedrivenew.png": "efb5",
	"./icons/opera.png": "2fad",
	"./icons/parachute.svg": "666b",
	"./icons/pdf.png": "f35f",
	"./icons/psd.png": "3a95",
	"./icons/react.svg": "f4d6",
	"./icons/rocket.svg": "df02",
	"./icons/sketch.png": "c62d",
	"./icons/speaker.svg": "1535",
	"./icons/star.svg": "0a83",
	"./icons/toolbox.svg": "40d5",
	"./icons/txt.png": "d36d",
	"./icons/unknown.png": "91ed",
	"./icons/vuejs.svg": "57c1",
	"./icons/xls.png": "d75a",
	"./illustration/back.png": "313f",
	"./illustration/badge.svg": "6ca7",
	"./illustration/email.svg": "9da9",
	"./interactive-avatars/1/idle.png": "2221",
	"./interactive-avatars/1/right.png": "e049",
	"./interactive-avatars/1/sleep.png": "9c34",
	"./interactive-avatars/1/wrong.png": "8f3c",
	"./interactive-avatars/2/idle.png": "646e",
	"./interactive-avatars/2/right.png": "2018",
	"./interactive-avatars/2/sleep.png": "b348",
	"./interactive-avatars/2/wrong.png": "6052",
	"./interactive-avatars/3/idle.png": "6242",
	"./interactive-avatars/3/right.png": "0eab",
	"./interactive-avatars/3/sleep.png": "128c",
	"./interactive-avatars/3/wrong.png": "81e1",
	"./interactive-avatars/4/idle.png": "fb34",
	"./interactive-avatars/4/right.png": "a43c",
	"./interactive-avatars/4/sleep.png": "50ab",
	"./interactive-avatars/4/wrong.png": "74c8",
	"./interactive-avatars/5/idle.png": "f84f",
	"./interactive-avatars/5/right.png": "890b",
	"./interactive-avatars/5/sleep.png": "5b3a",
	"./interactive-avatars/5/wrong.png": "1884",
	"./interactive-avatars/6/idle.png": "d75f",
	"./interactive-avatars/6/right.png": "b394",
	"./interactive-avatars/6/sleep.png": "7435",
	"./interactive-avatars/6/wrong.png": "1dd7",
	"./landing/1.svg": "ea7f",
	"./landing/2.svg": "d770",
	"./landing/3.svg": "2fb1",
	"./landing/bg.jpg": "5ffc",
	"./landing/circle-1.png": "4d8d",
	"./landing/circle-1.svg": "b73c",
	"./landing/circle-2.png": "e49f",
	"./landing/circle-2.svg": "c034",
	"./landing/circle-3.png": "f22d",
	"./landing/circle-3.svg": "7cac",
	"./landing/elem.jpg": "f4e3",
	"./landing/hs.jpg": "3956",
	"./landing/illustrator.png": "3c7c",
	"./landing/img1.jpg": "2aa8",
	"./landing/img2.jpg": "9aa9",
	"./landing/img3.jpg": "f0ca",
	"./landing/kinder.jpg": "d998",
	"./landing/logo.svg": "cff1",
	"./landing/mob-circle-1.png": "e3e0",
	"./landing/mob-circle-2.png": "4351",
	"./landing/mob-circle-3.png": "d36e",
	"./landing/ms.jpg": "26b0",
	"./landing/pause-btn.png": "6619",
	"./landing/play-btn.svg": "83e5",
	"./landing/teacher.jpg": "db290",
	"./landing/uni.jpg": "6db3",
	"./logo/jaac-logo.svg": "afdf",
	"./logo/logo.svg": "ed29",
	"./logo/new-logo.svg": "1de7",
	"./pages/arrow-down.png": "ba74",
	"./pages/auth-v1-bottom-bg.png": "cc4f",
	"./pages/auth-v1-top-bg.png": "06c1",
	"./pages/calendar-illustration.png": "8c71",
	"./pages/coming-soon-dark.svg": "c09f",
	"./pages/coming-soon.svg": "7b13",
	"./pages/content-img-1.jpg": "86ad",
	"./pages/content-img-2.jpg": "d3a8",
	"./pages/content-img-3.jpg": "b4db",
	"./pages/content-img-4.jpg": "b51c",
	"./pages/error-dark.svg": "e0c1",
	"./pages/error.png": "a370",
	"./pages/error.svg": "053b",
	"./pages/forgot-password-v2-dark.svg": "6e2f",
	"./pages/forgot-password-v2.png": "657c",
	"./pages/forgot-password-v2.svg": "5b2a",
	"./pages/forgot-password.png": "95e0",
	"./pages/glass.png": "ac15",
	"./pages/kb-image.jpg": "6843",
	"./pages/lesson.jpg": "b7b3",
	"./pages/login-v2-1.png": "77de",
	"./pages/login-v2-dark.svg": "ff0f",
	"./pages/login-v2.png": "98a3",
	"./pages/login-v2.svg": "5aa9",
	"./pages/login/facebook.svg": "4631",
	"./pages/login/github.svg": "7b1ea",
	"./pages/login/google.svg": "74c7",
	"./pages/login/twitter.svg": "ceb3",
	"./pages/not-authorized-dark.svg": "a357",
	"./pages/not-authorized.png": "dd28",
	"./pages/not-authorized.svg": "e767",
	"./pages/pixinvent-logo.png": "0ec0",
	"./pages/register-v2-dark.svg": "99b7",
	"./pages/register-v2.png": "655d",
	"./pages/register-v2.svg": "67df",
	"./pages/reset-password-v2-dark.svg": "aed4",
	"./pages/reset-password-v2.svg": "ed94",
	"./pages/study.jpg": "da9d",
	"./pages/under-maintenance-dark.svg": "189d",
	"./pages/under-maintenance.svg": "70e7",
	"./permissions/firefox.png": "56e8",
	"./permissions/microsoft-edge.png": "1e0b",
	"./permissions/safari.png": "6d75",
	"./portrait/small/avatar-s-1.jpg": "b7fa",
	"./portrait/small/avatar-s-10.jpg": "351c",
	"./portrait/small/avatar-s-11.jpg": "3f31",
	"./portrait/small/avatar-s-12.jpg": "bb8e",
	"./portrait/small/avatar-s-13.jpg": "ecc1",
	"./portrait/small/avatar-s-14.jpg": "12d0",
	"./portrait/small/avatar-s-15.jpg": "e4ed",
	"./portrait/small/avatar-s-16.jpg": "6683",
	"./portrait/small/avatar-s-17.jpg": "87ae",
	"./portrait/small/avatar-s-18.jpg": "685b",
	"./portrait/small/avatar-s-19.jpg": "9ffc",
	"./portrait/small/avatar-s-2.jpg": "3423",
	"./portrait/small/avatar-s-20.jpg": "0160",
	"./portrait/small/avatar-s-21.jpg": "42f0",
	"./portrait/small/avatar-s-22.jpg": "97e6",
	"./portrait/small/avatar-s-23.jpg": "d0db",
	"./portrait/small/avatar-s-24.jpg": "63bb",
	"./portrait/small/avatar-s-25.jpg": "2565",
	"./portrait/small/avatar-s-26.jpg": "0262",
	"./portrait/small/avatar-s-3.jpg": "26fa",
	"./portrait/small/avatar-s-4.jpg": "fbb2",
	"./portrait/small/avatar-s-5.jpg": "9a5e",
	"./portrait/small/avatar-s-6.jpg": "fa7b",
	"./portrait/small/avatar-s-7.jpg": "b690",
	"./portrait/small/avatar-s-8.jpg": "ed5f",
	"./portrait/small/avatar-s-9.jpg": "f2be",
	"./qr/android.png": "e2b7",
	"./qr/ios.png": "c4b4",
	"./shapes/cyan_rectangle.png": "e640",
	"./shapes/green_rectangle.png": "ef45",
	"./shapes/hexagon.png": "1c14",
	"./shapes/horizontal_board.png": "bb07",
	"./vibes-instructions/vibes-1.png": "49ca",
	"./vibes-instructions/vibes-2.png": "5206",
	"./vibes-instructions/vibes-3.png": "6fa6",
	"./vibes-instructions/vibes-4.png": "7723",
	"./vibes-instructions/vibes-5.png": "56e87",
	"./vibes-instructions/vibes-6.png": "40f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";